export const ONBOARDING_STORAGE_KEY_PREFIX = 'lotto_assistant_onboarding';

export const getOnboardingStorageKey = (userId) =>
  `${ONBOARDING_STORAGE_KEY_PREFIX}_${userId}`;

export const ONBOARDING_STEPS = [
  {
    id: 'chat-input',
    title: 'Chat with the assistant',
    body: 'Create lottery tickets, check upcoming draws, and get results with the AI assistant.',
    placement: 'top',
  },
  {
    id: 'browse-lotteries',
    title: 'Browse lotteries',
    body: 'Explore available lotteries and find upcoming draws — never miss a chance to play.',
    placement: 'top',
  },
  {
    id: 'lotto-results',
    title: 'Latest results',
    body: 'Check winning numbers from the latest draws and see if luck was on your side.',
    placement: 'top',
  },
  {
    id: 'my-bets',
    title: 'Your bets',
    body: 'Track your active, settled, and subscription bets in one place.',
    placement: 'top',
  },
  {
    id: 'cart',
    title: 'Your cart',
    body: 'Review your selected tickets and place your bets before the draw closes.',
    placement: 'top',
  },
];

export const TOOLTIP_GAP = 12;
export const VIEWPORT_MARGIN = 8;
export const AUTO_START_DELAY_MS = 600;
export const TOOLTIP_WIDTH = 320;
